/**
 * Fiscal Printer - constants and control codes
 */

export const ESC = 0x1B;
export const CR = 0x0D;

export const DEFAULT_PROTOCOL = localStorage.getItem('fiscal_printer_protocol') || 'xml';

export const SERIAL_PORT_OPTIONS = {
  baudRate: 9600,
  dataBits: 8,
  stopBits: 1,
  parity: 'none',
  flowControl: 'none'
};

// Windows-1250 encoding map for Polish characters
export const WIN1250_MAP = {
  'ą': 0xB9, 'ć': 0xE6, 'ę': 0xEA, 'ł': 0xB3, 'ń': 0xF1,
  'ó': 0xF3, 'ś': 0x9C, 'ź': 0x9F, 'ż': 0xBF,
  'Ą': 0xA5, 'Ć': 0xC6, 'Ę': 0xCA, 'Ł': 0xA3, 'Ń': 0xD1,
  'Ó': 0xD3, 'Ś': 0x8C, 'Ź': 0x8F, 'Ż': 0xAF
};

// Polish diacritics → ASCII map for cashier name field
export const DIACRITICS_ASCII_MAP = {
  'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n',
  'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
  'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N',
  'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z'
};

// VAT rate → Novitus letter mapping
export const VAT_RATE_MAP = {
  23: 'A',
  8:  'B',
  5:  'C',
  0:  'D',
  '-1': 'Z', // Zwolniony z VAT
  '-2': 'G'  // Niepodlegający VAT (kaucje)
};

// Payment type → XML type mapping
export const PAYMENT_TYPE_MAP = [
  { keys: ['gotowka', 'cash'],           type: 'cash',     name: 'Gotowka' },
  { keys: ['karta', 'card'],             type: 'card',     name: 'Karta'   },
  { keys: ['przelew', 'transfer'],       type: 'transfer', name: 'Przelew' },
  { keys: ['mobile', 'blik'],            type: 'mobile',   name: 'BLIK'    },
  { keys: ['czek', 'cheque'],            type: 'cheque',   name: 'Czek'    },
  { keys: ['kredyt', 'credit'],          type: 'credit',   name: 'Kredyt'  },
  { keys: ['bon', 'voucher', 'kupon', 'coupon'], type: 'voucher', name: 'Kupon' }
];
